import { Bond } from '@goldwasserexchange/common/lib/bond';
import { parseActorDate } from '../../../../shared/utils/parseDates';
import { BondResponse } from '../type';
import { memoCreateBond, memoGetPrice, memoGetYield } from './memoCreateBond';
import { transformSAccJrsFreqToBondFrequency } from './transformSAccJrsFreqToBondFrequency';

export function makeNetBondCalculator(bondsBond: BondResponse): Bond
export function makeNetBondCalculator(bondsBond: undefined): undefined
export function makeNetBondCalculator(bondsBond: BondResponse | undefined): Bond | undefined
export function makeNetBondCalculator(bondsBond: BondResponse | undefined): Bond | undefined {
  if (bondsBond == null) {
    return undefined;
  }
  const {
    'S_ACC.INT_RATE': rate,
    'S_ACC.OBL_END_DATE': maturity,
    'S_ACC.OBL_END_PRICE': redemption,
    'S_ACC_JRS.FREQ': sAccJrsFreq,
    'S_ACC.ISSUE_DATE': issue,
    'S_ACC.OBL_FIRST_CPS': firstCoupon,
    'S_ACC_BE.RATE_PREC_CPS': taxRate,
  } = bondsBond;
  const frequency = transformSAccJrsFreqToBondFrequency(sAccJrsFreq);
  if (frequency == null || rate == null || taxRate == null || maturity == null || redemption == null || issue == null) {
    return undefined;
  }
  const bondCalculator = memoCreateBond({
    rate: (rate / 100) * (1 - taxRate / 100),
    maturity: parseActorDate(maturity),
    redemption,
    frequency,
    issue: parseActorDate(issue),
    firstCoupon: firstCoupon ? parseActorDate(firstCoupon) : undefined,
  });
  return bondCalculator;
}

export const makeNetBondYieldCalculator = (bondsBond: BondResponse | undefined) => {
  if (bondsBond == null) {
    return undefined;
  }
  const bond = makeNetBondCalculator(bondsBond);
  const getYield = (price: number) => memoGetYield(bond, price);
  return getYield;
};

export const makeNetBondPriceCalculator = (bondsBond: BondResponse | undefined) => {
  if (bondsBond == null) {
    return undefined;
  }
  const bond = makeNetBondCalculator(bondsBond);
  const getYield = (yld: number) => memoGetPrice(bond, yld);
  return getYield;
};
